import {
  EnumFunnelTrackingCookies,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'

/**
 *
 */
export function persistLastEngagedActiveLiveStreamId(
  encodedLiveStreamId: string,
) {
  setCookieWithFallback(
    EnumFunnelTrackingCookies.FW_LAST_ENGAGED_ACTIVE_LIVESTREAM_ID,
    encodedLiveStreamId,
  )
}
